import tagTester from './_tagTester.js';

export default tagTester('Symbol');



//////////////////
// WEBPACK FOOTER
// ./node_modules/underscore/modules/isSymbol.js
// module id = 184
// module chunks = 0 1